const GrapichsListView = () => {
	return (
		<div>
			<div className="single-table mt-4 mb-4">
				<p className="semibold-14 text-underline mb-12 cursor-pointer">Graphics list view</p>
				<div className="costing-details-view-table">
					<table className="table with-border scroll-x-label">
						<thead>
							<tr>
								<th>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="selectAllGeneralList"
												name="selectAllGeneralList"
											/>
											<label htmlFor="selectAllGeneralList" />
										</div>
									</div>
								</th>
								<th>Design</th>
								<th>Costing</th>
								<th>Sample ID</th>
								<th>Location</th>
								<th>Fabric</th>
								<th>Trims</th>
								<th>Tag</th>
								<th>Remark</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="select-box-column" rowSpan={2}>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="general_list_1"
												name="general_list_1"
											/>
											<label htmlFor="general_list_1" />
										</div>
									</div>
								</td>
								<td className="style-details-column design-column" rowSpan={2}>
									<div className="d-flex align-items-center">
										<img
											src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
											alt="design"
											className="cell-img pr-2"
										/>
										<div>
											<p className="semibold-14 gray_dark_01 mb-0">WT25-A0548</p>
											<p className="regular-12 gray_dark_02 mb-0">Women - SWEATSHIRT</p>
											<p className="regular-12 gray_dark_02 mb-0">Bratty</p>
										</div>
									</div>
								</td>
								<td className="status-date-column costing-column" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">-</p>
								</td>
								<td className="sample-td location-td" rowSpan={1}>
									<p className="regular-14 gray_dark_02 mb-0">BD: 547856</p>
								</td>
								<td className="location-td" rowSpan={1}>
									<p className="regular-14 gray_dark_02 mb-0">
										LBD#1068, BD, Virgil Aloha, B1, 101, CYAN, SL-3
									</p>
								</td>
								<td className="fabric-column" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">
										-Single Jersey, 95.5% Pima Cotton, 5.0% Hemp, 350.0 GSM, Rinse Washing
									</p>
								</td>
								<td className="trims fabric-column" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">-</p>
								</td>
								<td className="tag tag-columm" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">-</p>
								</td>
								<td rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">-</p>
								</td>
							</tr>
							<tr>
								<td className="sample-td location-td" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">UK: 8569856</p>
								</td>
								<td className="location-td" rowSpan={2}>
									<p className="regular-14 gray_dark_02 mb-0">
										LBD#1060, TR, Versace, B1, 204, CYAN, SL-1, Store located in turkey
									</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};
export default GrapichsListView;
